<template>
  <div class="w-full flex justify-start items-center flex-col h-full">

    <div v-if="$accessToken"  class="w-full h-full max-w-screen-xl overflow-hidden xl:border-x xl:border-x-white/20 flex flex-col justify-start items-start sm:pb-0 pb-[50vh] overflow-y-auto">
      <div class=" relative z-10 w-full h-full ">
  
        <main class="grid grid-cols-3 w-full">
          <nav class="w-full block px-4 py-8 border-b border-b-white/20 col-span-full">
            <NuxtLink to="/app">
              <button class="bg-turquoise-500/20 border-turquoise-900 text-turquoise-500 shadow-xl rounded-full btn btn-circle btn-sm mb-4">
                <Icon name="mdi:arrow-left"></Icon>
              </button>
            </NuxtLink>
            

            <div class="flex justify-between">

              <div>
                <div class="flex justify-start items-center space-x-2">
                  <h1 class="text-3xl font-light text-white">Claim Center</h1>
                  <div class="bg-red-600 text-sm font-bold tracking-widest text-white py-0.5 px-2 rounded-md">BETA</div>
                </div>
                <p>View and claim tokens from your contributions</p>
    
                <div class="w-full flex justify-start items-center">
                  <div class="mt-4 bg-white/10 rounded-lg p-2 pr-4 flex justify-center items-center space-x-2">
                    <Icon name="mdi:information" class="text-turquoise-500 text-lg"></Icon>
                    <p class="text-white">Expand Project to Claim</p>
                  </div>
                </div>
              </div>

              <div v-if="multiClaimList.length > 0 && !isMobile">
                  <div class="m-2 border-white">
    
                    <div class="flex justify-between">
                      <div class="flex">
                        <button class="btn btn-link text-red-400" @click="clearMultiClaim()">Clear</button>
                        <button class="btn btn-link text-turquoise" @click="viewMultiClaim()">View</button>
                        <button @click="viewMultiClaim()" class="btn bg-turquoise-500 rounded-full sm:text-xl text-lg sm:px-8 px-4 tracking-widest font-semibold hover:text-white border-transparent shadow-turquoise-500/20 text-turquoise-900 mb-2">Claim ({{ multiClaimList.length }})</button>
                      </div>
    
                    </div>

                  </div>
              </div>

            </div>

            



    
          </nav>

          <div v-if="multiClaimList.length > 0 && isMobile" id="mcHeader" class="w-full flex justify-end items-center space-x-8 p-2 border-b border-b-white/10 col-span-full top-0 z-70 bg-woodsmoke-850">
            <div class="w-full">
                <div class="flex justify-between items-center w-full">
                  <button class="btn text-sm btn-link text-red-400" @click="clearMultiClaim()">Clear</button>
                  <button class="btn text-sm btn-link text-turquoise" @click="viewMultiClaim()">View</button>
                  <button @click="viewMultiClaim()" class="btn btn-sm bg-turquoise-500 rounded-full text-sm px-4 tracking-widest font-semibold hover:text-white border-transparent shadow-turquoise-500/20 text-turquoise-900">Claim ({{ multiClaimList.length }})</button>
                </div>
            </div>
          </div>
  
          <template  v-if="!loading">
            <div class="w-full flex justify-start items-center space-x-8 p-2 border-b border-b-white/10 col-span-full sticky top-0 z-50 bg-woodsmoke-850">
                
      
                <div class="flex relative">
                  <div v-if="vestingBubbleCount>0" class="w-5 h-5 bg-turquoise-500 rounded-full flex justify-center items-center text-sm font-bold text-black absolute -top-2 -right-2">
                    {{ vestingBubbleCount }}
                  </div>
                  <button @click="selectTab('vestings')" :class="[selectedTab=='vestings'?'text-turquoise-500 bg-white/10':'btn-ghost']" class="btn">Vestings</button>
                </div>
                
                <div class="flex relative">
                  <div v-if="refundBubbleCount>0" class="w-5 h-5 bg-turquoise-500 rounded-full flex justify-center items-center text-sm font-bold text-black absolute -top-2 -right-2">
                    {{ refundBubbleCount }}
                  </div>
                  <button @click="selectTab('oversub_claim')" :class="[selectedTab=='oversub_claim'?'text-turquoise-500 bg-white/10':'btn-ghost']" class="btn">Refund</button>
                </div>
            </div>
      
            <div :class="[isMobile ? 'col-span-full': (_dates?'col-span-2 border-r border-r-white/10':'col-span-full')]" class="w-full h-full">
              <!-- <ClaimProject :currentFocus="focus" :class="[focus?(focus==i?'':'opacity-20'):'']" v-for="i in 10" @focus="setFocus" @schedule="viewSchedule" :id="i"></ClaimProject> -->
              <template v-if="selectedTab == 'vestings'">
                <ClaimProject :class="[focus?(focus==_claim.project.project_id?'':''):'']" :address="$address" :chainId="$chainId" :currentFocus="focus" :entry="_claim" v-for="_claim in vestings" @focus="setFocus" @schedule="viewSchedule" @multiclaim="populateMulticlaim" :id="_claim.project.project_id"></ClaimProject>
                
                <div v-if="!(vestings?.length > 0)" class="w-full p-8">
                  <p class="text-xl text-white">No Vesting Found</p>
                  <p>If you believe this is an error, please contact admin in <a class="underline text-turquoise-500" target="_blank" href="https://t.me/oxbull_tech">t.me/oxbull_tech</a> </p>
                </div>
              
              </template>
      
              <template v-if="selectedTab == 'oversub_claim'">
                <ClaimProject :class="[focus?(focus==_claim.project.project_id?'':''):'']" :address="$address" :chainId="$chainId" :currentFocus="focus" :entry="_claim" v-for="_claim in refunds" @focus="setFocus" @schedule="viewSchedule" :id="_claim.project.project_id"></ClaimProject>
                
                <div v-if="!(refunds?.length > 0)" class="w-full p-8">
                  <p class="text-xl text-white">No Refunds Found</p>
                  <p>If you believe this is an error, please contact admin in <a class="underline text-turquoise-500" target="_blank" href="https://t.me/oxbull_tech">t.me/oxbull_tech</a> </p>
                </div>
  
              </template>
            </div>
      
            <div class="bg-woodsmoke-850" v-if="!isMobile && _dates">
              <ClaimSchedule @close="closeSchedule" :dates="_dates"></ClaimSchedule>
            </div>
      
              <div v-if="isMobile">
                <HeadlessTransitionRoot as="template" :show="showScheduleModal">
                  <HeadlessDialog as="div" class="relative z-[1000]" @close="showScheduleModal = false">
                    <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </HeadlessTransitionChild>
          
                    <div class="fixed inset-0 z-[999999999999] overflow-y-auto">
                      <div class="flex min-h-full items-center justify-center p-4 text-center">
                        <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                          <HeadlessDialogPanel class="relative transform transition-all w-full">
                            <div class="w-full bg-woodsmoke-850 p-4 rounded-xl">
                              <ClaimSchedule @close="closeSchedule" :dates="_dates"></ClaimSchedule>
                            </div>
                          </HeadlessDialogPanel>
                        </HeadlessTransitionChild>
                      </div>
                    </div>
                  </HeadlessDialog>
                </HeadlessTransitionRoot>


                <HeadlessTransitionRoot as="template" :show="showMultiClaimDialog">
                  <HeadlessDialog as="div" class="relative z-[1000]" @close="showMultiClaimDialog = false">

                    <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </HeadlessTransitionChild>

                    <div class="fixed inset-0 z-[999999999999] overflow-y-auto">
                      <div class="flex min-h-full items-center justify-center p-4 text-center">
                        <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                          <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-black px-4 pb-4 pt-5 text-left shadow-xl transition-all w-full">
                            
                            <div @click="showMultiClaimDialog = false" class="flex justify-end text-white cursor-pointer">
                              <Icon name="mdi:close" class="text-xl"/>
                            </div>

                            <div>

                              <div class="text-center">
                                <HeadlessDialogTitle as="h3" class="text-base font-semibold leading-6 text-white-900">Bulk Claim</HeadlessDialogTitle>
                                <div class="mt-5 text-left">
                                  <!-- {{  computeMultiClaimListSummary  }} -->
                                  <!-- <button @click="computeMultiClaimListSummary()">GG</button> -->
                                  <div v-for="(project,index) of computeMultiClaimListSummary">
                                    <!-- {{ project?.project_name }} -->
                                    <!-- <div>{{ vesting }}</div> -->
                                    <div class="flex justify-between text-lg text-white pt-2">
                                      <p>{{ project?.project_name }}</p>
                                      <p>Total : {{ Math.floor(project?.project_total_token *10000) / 10000 }} {{ project?.vesting[0].symbol }}</p>
                                    </div>
                                    <div v-for="(vest,i) of project?.vesting">
                                      <div class="flex justify-between text-sm">
                                        <p>{{ i+1 }}. {{ vest?.topic }}</p>
                                        <p>{{ Math.floor(vest?.available_amount * 10000) / 10000 }} {{ vest?.symbol }}</p>
                                      </div>
                                    </div>

                                  </div>
                                  <!-- <p class="text-sm text-gray-500">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur amet labore.</p> -->
                                </div>
                              </div>

                            </div>

                            <div class="mt-5 sm:mt-6">
                              <button type="button" class="inline-flex w-full justify-center rounded-md bg-turquoise-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-turquoise-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-turquoise-600" @click="multiclaim()">Claim All</button>
                            </div>

                          </HeadlessDialogPanel>
                        </HeadlessTransitionChild>
                      </div>
                    </div>
                  </HeadlessDialog>
                </HeadlessTransitionRoot>
              </div>
          
          </template>
  
          <div class="w-full flex justify-center items-center col-span-full h-[50vh]" v-else>
          <Icon name="eos-icons:loading" class="text-5xl"></Icon>
        </div>
    
          
          
        </main>
  
        
      </div>
    </div>


    <div v-else class="w-full h-full flex justify-center items-center flex-col font-light text-center px-8 min-h-screen">
        <h1 class="text-3xl">Connect Wallet to Proceed</h1>

        <WalletModal>
          <button class="btn bg-turquoise-600 mt-4 text-black hover:text-white">Connect Wallet</button>
        </WalletModal>

        <div class="pt-12">
          <NuxtLink to="/app">
            <button class="btn btn-link text-red-500">return to home</button>
          </NuxtLink>
        </div>
      </div>
    
  </div>


  <HeadlessTransitionRoot v-if="!isMobile" as="template" :show="showMultiClaimDialog">
    <HeadlessDialog as="div" class="relative z-10" @close="showMultiClaimDialog = false">

      <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </HeadlessTransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">

        

        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-black px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
              
              <div @click="showMultiClaimDialog = false" class="flex justify-end text-white cursor-pointer">
                <Icon name="mdi:close" class="text-xl"/>
              </div>

              <div>

                <div class="text-center">
                  <HeadlessDialogTitle as="h3" class="text-base font-semibold leading-6 text-white-900">Bulk Claim</HeadlessDialogTitle>
                  <div class="mt-5 text-left">
                    <!-- {{  computeMultiClaimListSummary  }} -->
                    <!-- <button @click="computeMultiClaimListSummary()">GG</button> -->
                    <div v-for="(project,index) of computeMultiClaimListSummary">
                      <!-- {{ project?.project_name }} -->
                      <!-- <div>{{ vesting }}</div> -->
                      <div class="flex justify-between text-lg text-white pt-2">
                        <p>{{ project?.project_name }}</p>
                        <p>Total : {{ Math.floor(project?.project_total_token *10000) / 10000 }} {{ project?.vesting[0].symbol }}</p>
                      </div>
                      <div v-for="(vest,i) of project?.vesting">
                        <div class="flex justify-between text-sm">
                          <p>{{ i+1 }}. {{ vest?.topic }}</p>
                          <p>{{ Math.floor(vest?.available_amount * 10000) / 10000 }} {{ vest?.symbol }}</p>
                        </div>
                      </div>

                    </div>
                    <!-- <p class="text-sm text-gray-500">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consequatur amet labore.</p> -->
                  </div>
                </div>

              </div>

              <div class="mt-5 sm:mt-6">
                <button type="button" class="inline-flex w-full justify-center rounded-md bg-turquoise-900 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-turquoise-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-turquoise-600" @click="multiclaim()">Claim All</button>
              </div>

            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>


</template>

<script setup>
definePageMeta({
  layout: "app",
  name: "claim",
  // middleware:["claim"]
});

import { useUserStore } from "~/stores/user.js";
const userStore = useUserStore();

// import { config } from "~/wagmiConfig.js";
// import { getAccount, watchAccount, watchConnections } from "@wagmi/core";

// Read the query for selected tab. if none is selected, default to "vestings"

const route = useRoute()
const router = useRouter()

import { useEventBus } from '@vueuse/core'
const bus = useEventBus('reload')

const busMC = useEventBus('resetMulticlaim')

const toast = useToast();

const _toast = (param) => {
  toast.add({
    ...param,
    ui: {
      strategy: "override",
      icon: {
        base: "flex-shrink-0 w-5 h-5 mt-0.5",
        color: "text-{color}-500 dark:text-{color}-400",
      },
      background: "bg-woodsmoke-800/50 backdrop-blur-md",
      container: "border border-turquoise-500/20 relative overflow-hidden",
      title: "text-turquoise-500 text-base",
      description: "text-white text-sm",
    },
  });
};

// console.clear()
// console.log(bus)

bus.on((ev) => {
  // console.log(ev)
  renderClaims()
  // alert('hi')
})

const selectedTab = ref(route.query.tab || "vestings")

if(!route.query.tab){
  router.push({ query: { tab: 'vestings' } })
}

const selectTab = (tab) => {
  selectedTab.value = tab;
  focus.value = false;
  router.push({ query: { tab: tab } })
}

// const address = ref("");
// const chainId = ref(-1);

import { useScreens } from "vue-screen-utils";

const { mapCurrent } = useScreens({
  xs: "0px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
});

const isMobile = mapCurrent({
  xs: true,
  sm: true,
  md: true,
  lg: false,
});

// const unwatch = watchConnections(config, {
//   onChange(data) {
//     if (data) {
//       let _account = getAccount(config);
//       address.value = _account.address;
//       chainId.value = _account.chainId;
//     } else {
//       address.value = null;
//     }
//     renderClaims();
//   },
// });

// const unwatchAccount = watchAccount(config, {
//   onChange(data) {
//     renderClaims();
//   },
// });

// const unsub = userStore.$subscribe((state) => {
//   renderClaims();
// });

const { $address, $chainId, $accessToken, $wagmiConfig, $multiCallContract } = useNuxtApp()
import { switchChain, getBalance, waitForTransactionReceipt, writeContract, readContract } from "@wagmi/core";

const vestings = ref([]);
const refunds = ref([]);

const loading = ref(false);

let throttle = null;

const renderClaims = async () => {
  // console.log("rendering claims");

  let main = ( async () => {
    loading.value = true;

    if($address.value){
      posthogStore.identifyUser($address.value, {
        address: $address.value
      });
    }

    if($accessToken.value){
      // let _result = await getVestingProject();
      const { $fetchVesting } = useNuxtApp()
      try{

        // let token = useCookie(`${$address.value}_token`, {
        //   readonly: true
        // })
        
        // await $fetchVesting({
        //   address: $address.value,
        //   token: token
        // })

        let result = await $fetch('/api/vesting')

        console.log(result)

        let vestingState = useState('vesting')
        // console.log(vestingState.value)

        vestingState.value = result

        vestings.value = vestingState?.value?.vesting;
        refunds.value = vestingState?.value?.refund;

        posthogStore.posthogRef.capture('Render Claim', { 
          wallet_address: $address.value,
          vesting: vestings.value,
          refund: refunds.value
        })

      }catch(err){
        console.log(err)
      }
    }

    loading.value = false;
  })

  if(throttle){
    clearTimeout(throttle);
  }

  throttle = setTimeout(() => {
    main();
  }, 200);

};

const focus = ref(false);

const setFocus = (e) => {
  focus.value = e;
  _dates.value = false;
};

const _dates = ref(false);
const showScheduleModal = ref(false);

const viewSchedule = (e) => {
  if(e){
    _dates.value = e;
    showScheduleModal.value = true;
  }else{
    _dates.value = false;
    showScheduleModal.value = false;
  }
}

const closeSchedule = () => {
  _dates.value = false;
  showScheduleModal.value = false;
}



// import { queryNoCache } from "~/apollo";
// import { gql } from "@apollo/client/core";

// const getVestingProject = () => {
//   return new Promise(async (resolve) => {
//     let gqlResult = await queryNoCache(
//       gql`
//         query GetVestingProjectList {
//           getVestingProjectList {

//             vesting {
//               claimable
//               symbol
//               contribution_symbol
//               total_claimable_token
//               total_claimed_progress
//               total_claimed_token
//               total_effective_contribution
//               project {
//                 project_name
//                 project_logo
//                 project_id
//               }
//               vestings {
//                 available_amount
//                 claimable
//                 claimed_amount
//                 schedule_type
//                 topic
//                 total_claimable_amount
//                 primary
//                 progress
//                 refunded
//                 pool {
//                   claim_title
//                   chain
//                   symbol
//                   type_desc
//                   type
//                   primary
//                   has_fee
//                   project_id
//                   refund
//                   decimal
//                 }
//                 activities {
//                   userAddress
//                   blockTimestamp
//                   tokenAmountEtherNumber
//                   fromAddress
//                 }
//                 refund_pool {
//                   vesting_ca
//                   chain
//                   contract_address
//                   decimal
//                   start
//                   refund_title
//                   symbol
//                 }
//                 schedule {
//                   timestamp
//                   amount
//                   percent
//                 }
//                 whitelist {
//                   token_claimable_amount
//                   project_id
//                   user_address
//                   vesting_ca
//                 }
//               }
//             } refund {
//               claimable
//               symbol
//               contribution_symbol
//               total_claimable_token
//               total_claimed_progress
//               total_claimed_token
//               total_effective_contribution
//               project {
//                 project_name
//                 project_logo
//                 project_id
//               }
//               vestings {
//                 available_amount
//                 claimable
//                 claimed_amount
//                 schedule_type
//                 topic
//                 total_claimable_amount
//                 primary
//                 progress
//                 refunded
//                 pool {
//                   claim_title
//                   chain
//                   symbol
//                   type_desc
//                   type
//                   primary
//                   has_fee
//                   project_id
//                   refund
//                   decimal
//                 }
//                 activities {
//                   userAddress
//                   blockTimestamp
//                   tokenAmountEtherNumber
//                   fromAddress
//                   transactionHash
//                 }
//                 refund_pool {
//                   vesting_ca
//                   chain
//                   contract_address
//                   decimal
//                   start
//                   refund_title
//                   symbol
//                 }
//                 schedule {
//                   timestamp
//                   amount
//                   percent
//                 }
//                 whitelist {
//                   token_claimable_amount
//                   project_id
//                   user_address
//                   vesting_ca
//                 }
//               }
//             }
            


//           }
//         }
//       `,
//       {
        
//       }
//     );

//     // console.log('gqlResult', gqlResult);
//     resolve(gqlResult);
//   });
// };

let vestingState = useState('vesting')
// console.log(vestingState)

if(vestingState?.value){
  vestings.value = vestingState.value.vesting;
  refunds.value = vestingState.value.refund;
}


import { usePosthogStore } from "~/stores/posthogStore";
const posthogStore = usePosthogStore();

onMounted( () => {

  posthogStore.initPosthog();
  if($address.value){
    posthogStore.identifyUser($address.value, {
      address: $address.value
    });
  }
  
  renderClaims();

  watch($address, () => {
    renderClaims()
  })

  watch($chainId, () => {
    renderClaims()
  })

  watch($accessToken, () => {
    renderClaims()
  })

  // insertScrollRender();
})

const vestingBubbleCount = computed(() => {

  let _count = 0;

  if(!vestings.value){
    return 0;
  }

  vestings.value.forEach((vesting) => {
    if(vesting.total_claimed_token < vesting.total_claimable_token){
      _count++;
    }
  });

  return _count;

});

const refundBubbleCount = computed(() => {

  let _count = 0;

  if(!refunds.value){
    return 0;
  }

  refunds.value.forEach((refund) => {
    if(refund.total_claimed_token < refund.total_claimable_token){
      _count++;
    }
  });

  return _count;

});


const multiClaimList = ref([]);
const populateMulticlaim = (_vesting) => {

  // console.log('_vesting', _vesting)
  multiClaimList.value = _vesting?.vesting

}

const clearMultiClaim = () => {
  multiClaimList.value = [];
  busMC.emit(true);
}

const showMultiClaimDialog = ref(false)
const viewMultiClaim = () => {
  console.log("showMultiClaimDialog", showMultiClaimDialog.value);
  showMultiClaimDialog.value = !showMultiClaimDialog.value;
}

const multiclaim = async () => {

  console.log('multiclaim', multiClaimList.value)

  // need more than 2, less than 10
  if(multiClaimList.value.length < 2 || multiClaimList.value.length > 10) {
    alert("Multi claim list should not less than 2 and more than 10.");
    return;
  }

  userStore.pauseUI = true;
  showMultiClaimDialog.value = false;

  const requiredEthFee = await estimateETHFee(multiClaimList.value[0]);
  // console.log('requiredEthFee', requiredEthFee);

    
  try {

    const _claim = await writeContract($wagmiConfig, {
      abi: [
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "to",
                  "type": "address"
                },
                {
                  "internalType": "bytes",
                  "name": "data",
                  "type": "bytes"
                }
              ],
              "internalType": "struct MulticallVestingV3.Call[]",
              "name": "calls",
              "type": "tuple[]"
            }
          ],
          "name": "claimAll",
          "outputs": [],
          "stateMutability": "payable",
          "type": "function"
        },
      ],
      address: $multiCallContract.value[multiClaimList.value[0].chainId],
      functionName: "claimAll",
      args: [
        multiClaimList.value.map(x => x.calldata)
      ],
      value: requiredEthFee * multiClaimList.value.length,
    });

    console.log('_claim', _claim)

    if (_claim) {
      let claimReceipt = await waitForTransactionReceipt($wagmiConfig, {
        hash: _claim,
        confirmations: 2,
      });

      // console.log(claimReceipt)

      _toast({
        id: "claim",
        title: "Claimed!",
        description: "Your claim has been successful.",
        timeout: 5000,
      });
    }

  } catch (e) {
    console.log(e);
    _toast({
      id: "claim",
      title: "Error",
      description: `${e.shortMessage}`,
      timeout: 5000,
    });
  }

  clearMultiClaim();
  userStore.pauseUI = false;

  

}

const computeMultiClaimListSummary = computed(() => {
  const key = "project_id"
  let projectSet = [];
  let result = [];
  multiClaimList.value.forEach((currentValue) => {
    let groupKey = currentValue.project[key];

    if (!projectSet.includes(groupKey)) {
      result.push({
        ...currentValue.project,
        project_total_token: currentValue.available_amount,
        vesting: [currentValue]
      });
      projectSet.push(groupKey)
    } else {
      for(let r of result) {
        if(r.project_id == groupKey) {
          r.project_total_token += currentValue.available_amount;
          r.vesting.push( currentValue );
        } 
      }
    }
  })
  return result;
  
})

const estimateETHFee = async (claim) => {
  try {
    const _fee = await readContract($wagmiConfig, {
      abi: [
        {
          inputs: [],
          name: "getCurrentFee",
          outputs: [
            {
              internalType: "uint256",
              name: "",
              type: "uint256",
            },
          ],
          stateMutability: "view",
          type: "function",
        },
      ],
      address: claim.contract_address,
      functionName: "getCurrentFee",
      chain: claim.chainId,
    });

    const etherFee = Number(_fee);
    // const scaleFactor = 10000;
    // const roundedNumber = Math.ceil(etherFee * scaleFactor) / scaleFactor;
    return etherFee;
  } catch (error) {
    console.log(error);
    return 0.005;
  }
};


const insertScrollRender = () => {
  // document.addEventListener('DOMContentLoaded', function() {
    window.addEventListener('scroll', function() {
        const header = document.getElementById('mcHeader');
        if(!header) return;
        // You can adjust '50' to the offset where you want the sticky behavior to start
        // console.log(header);
        // console.log(window.scrollY)
        if (window.scrollY > 250) {
          header.classList?.remove('flex');
            header.classList?.add('fixed', 'top-0', 'w-full', 'z-10');
        } else {
          header.classList?.add('flex');
            header.classList?.remove('fixed', 'top-0', 'w-full', 'z-10');
        }
    });
  // });
}

</script>

<style></style>
